import React from 'react';
import {useTranslation} from "react-i18next";

import APIModel from "../../Components/APIModel";


const Orders = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const ORDERS_COLUMNS = [
        {
            name: t('catalog.orders.columns.created_at', "Created at"),
            selector: "created_at",
        },
        {
            name: t('catalog.orders.columns.basket_human_readable', 'Shopping cart'),
            selector: "basket_human_readable",
        },
        {
            name: t('catalog.orders.columns.total', 'Total'),
            cell: row => <div>
                 {row.total.amount} {row.total.currency}
            </div>,
        },
        {
            name: t('catalog.orders.columns.contact_human_readable', 'Contacts'),
            selector: "contact_human_readable",
        },
    ];

    return <APIModel
        heading={t('catalog.orders.api_model.heading', 'Orders')}
        subheading=''
        icon="pe-7s-credit icon-gradient bg-sunny-morning"
        apiPath='shop/orders'
        tableColumns={ORDERS_COLUMNS}
        tableEmptyMessage={t('catalog.orders.api_model.message_empty', 'No orders')}
        match={match}
        hasFilters={true}
        creationDisabled={true}
    />;
};

export default Orders;
